import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Login from './paginas/Login.js';
import Admin from './paginas/Admin.js'
import Error404 from './paginas/Error404.js';
import Pos from './paginas/Pos.jsx';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import 'animate.css';

const queryClient = new QueryClient()

const App = () => {

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route exact path="/admin" element={<Admin />}></Route>
          <Route exact path="/pos" element={<Pos />}></Route>
          <Route path="/" element={<Login />} />
          <Route path='*' element={<Error404 />}></Route>
        </Routes>
      </QueryClientProvider>
    </BrowserRouter>
  )
}


export default App